import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataContextService } from 'src/app/services/datacontext.service';
import { ToasterService, ToasterType } from './toaster.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.less']
})
export class ToasterComponent implements OnInit {

  constructor(private toasterService: ToasterService, private dataContextService: DataContextService) { }
  showToaster: boolean = false;
  message: string;
  backgroundColor: string;
  toasterStayTime: number;

  ngOnInit(): void {
    this.dataContextService.masterDadaLoaded$.subscribe(res => {
      if(res) {
        this.toasterStayTime = DataContextService.Configurations.find(item => item.name == 'ToasterStayTimeMilliSec') ?  Number(DataContextService.Configurations.find((item) => item.name == 'ToasterStayTimeMilliSec').value) : null;
      }
    });
    
    this.toasterService.status$.subscribe(res => {
      if(res) {
        this.showToaster = true;
        this.message = res.message;
        if(res.type == ToasterType.success) {
          this.backgroundColor = '#29890d';
        }
        else {
          this.backgroundColor = '#DA291C'
        }
        setTimeout(() => {
          this.close();
        }, this.toasterStayTime);
      }
    })
  }

  close() {
    this.showToaster = false;
    this.toasterService.closeToaster();
  }
}
